function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "677E0C85-88ED-4187-8F3A-718A05A6FCBE");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M16.832748,3.62329182 L2.01169591,3.62329182 L2.01169591,12.7173353 L16.832748,12.7173353 L16.832748,3.62329182 Z M16.832748,2.78118656 L16.832748,1.04568728 L2.01169591,1.04568728 L2.01169591,2.78118656 L16.832748,2.78118656 Z M1.26315793,12.7173353 L1.26315793,0.671418268 C1.26315793,0.464715201 1.43072386,0.297149257 1.63742692,0.297149257 L17.207017,0.297149257 C17.4137201,0.297149257 17.581286,0.464715201 17.581286,0.671418268 L17.581286,12.7173353 L18.4046777,12.7173353 C18.6113807,12.7173353 18.7789467,12.905847 18.7789467,13.138388 C18.7789467,13.3709289 18.6113807,13.5594406 18.4046777,13.5594406 L10.5103666,13.5594406 L15.0936389,18.8093708 C15.2295788,18.9650837 15.2135495,19.201515 15.0578366,19.3374549 C14.9021237,19.4733947 14.6656924,19.4573655 14.5297526,19.3016525 L10.3391811,14.5015434 L10.3391811,19.6842836 C10.3391811,19.8909866 10.1506694,20.0585526 9.9181285,20.0585526 C9.68558755,20.0585526 9.49707587,19.8909866 9.49707587,19.6842836 L9.49707587,14.3943663 L5.21293714,19.3016525 C5.07699729,19.4573655 4.84056601,19.4733947 4.68485309,19.3374549 C4.52914017,19.201515 4.51311093,18.9650837 4.64905078,18.8093708 L9.23232307,13.5594406 L0.43976607,13.5594406 C0.233063014,13.5594406 0.0654970784,13.3709289 0.0654970784,13.138388 C0.0654970784,12.905847 0.233063014,12.7173353 0.43976607,12.7173353 L1.26315793,12.7173353 Z M10.3391811,13.5594406 L9.81168343,13.5594406 L10.3391811,14.5015434 L10.3391811,13.5594406 Z",
  id: "path-2"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "User-empty",
  transform: "translate(-512.000000, -124.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu",
  transform: "translate(0.000000, 92.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Class-not-selected",
  transform: "translate(506.000000, 23.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(0.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/Class"
}, /*#__PURE__*/React.createElement("g", {
  id: "Color/Primary/Brand",
  transform: "translate(6.203509, 5.971857)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#EAECF0",
  fillRule: "nonzero",
  xlinkHref: "#path-2"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask-2)",
  id: "Rectangle-Copy-3"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-5.894737, -5.894737)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 32,
  height: 32
}))))))))));

var SvgClass = function SvgClass(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    fill: "#9FA5B7",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Class.336bb503.svg";
export { ForwardRef as ReactComponent };